import type { FC, ReactNode } from 'react'

const ITEMS = [
    '6061-T6 aerospace aluminum',
    'Custom offset ET -15 to +45',
    '8.4 kg ultra light',
    '10-spoke diamond cut',
    'Deep concave profile',
    'Floating titanium center cap',
    '100% tailor-made fitment'
]

// Kinetic specification band between the film and the site
const SpecMarquee: FC = (): ReactNode => {
    return (
        <div className='relative overflow-hidden border-y border-white/5 bg-slate-deep py-5'>
            <p className='sr-only'>
                {ITEMS.join(', ')}
            </p>
            <div className='marquee-track flex w-max' aria-hidden='true'>
                {[0, 1].map((copy) => (
                    <ul key={copy} className='flex shrink-0 items-center'>
                        {ITEMS.map((item) => (
                            <li key={item} className='flex items-center gap-8 px-8 font-mono text-[11px] uppercase tracking-[0.32em] text-titanium-light'>
                                <span className='whitespace-nowrap'>{item}</span>
                                <span className='size-1.5 rotate-45 bg-gold' />
                            </li>
                        ))}
                    </ul>
                ))}
            </div>
            <div className='pointer-events-none absolute inset-y-0 left-0 w-24 bg-linear-to-r from-slate-deep to-transparent' aria-hidden='true' />
            <div className='pointer-events-none absolute inset-y-0 right-0 w-24 bg-linear-to-l from-slate-deep to-transparent' aria-hidden='true' />
        </div>
    )
}

export default SpecMarquee
